import { MyCanonComponent } from "./MyCanonComponent";

export function MyCanonScreen() {
  return (
    <>
      <MyCanonComponent />
    </>
  );
}
